import moment from 'moment';
import { MasterConfigs } from '../../interfaces/entity';
import { constants } from '../../constants/common';

export const offerLetterConfig: MasterConfigs = {
  api: () => '/offer-letter',
  title: 'Generate Offer Letter',
  isActionTab: true,
  maskClosable: false,
  modalTitle: (action) => action + ' Offer Letter',
  getColumns: () => {
    return [
      {
        title: 'Employee Name',
        dataIndex: 'candidate',
        key: 'candidate',
        render: (value) => {
          return value.candidateName;
        },
      },
      {
        title: 'Job Type',
        dataIndex: 'jobType',
        key: 'jobType',
        render: (value) => {
          return value;
        },
      },
      {
        title: 'Joining Date',
        dataIndex: 'date',
        key: 'date',
        render: (value) => {
          return moment(value).format('lll');
        },
      },
      {
        title: 'Reporting Manager',
        dataIndex: 'reportingManager',
        key: 'reportingManager',
        render: (value) => {
          return [value.firstName, value.lastName].join(' ');
        },
      },
      {
        title: 'Yearly Package',
        dataIndex: 'yearlyPackage',
        key: 'yearlyPackage',
        render: (value) => {
          return value;
        },
      },
      {
        title: 'First Pay',
        dataIndex: 'firstPay',
        key: 'firstPay',
        render: (value) => {
          return moment(value).format('lll');
        },
      },
      {
        title: 'Office Location',
        dataIndex: 'officeLocation',
        key: 'officeLocation',
      },
      {
        title: 'Generated?',
        dataIndex: 'offerLetterGenrated',
        key: 'offerLetterGenrated',
        render: (text) => {
          return text ? 'Done' : 'In-Progress';
        }
      },
      {
        title: 'Sent?',
        dataIndex: 'offerLetterSent',
        key: 'offerLetterSent',
        render: (text) => {
          return text ? 'Sent' : 'In-Progress';
        }
      },
      {
        title: 'Approval Status',
        dataIndex: 'approvalStatus',
        key: 'approvalStatus',
        render: (value) => {
          return value == 'PENDING' ? 'Doesn\'t send for approval' : value;
        },
      }
    ];
  },
  getFormColumns: () => {
    return [
      {
        label: 'Offer Letter For',
        name: 'candidate',
        type: 'text',
        // isCombo: true,
        rules: [{ required: true, message: 'Field is required' }]
      },
      {
        label: 'Joining Date',
        name: 'joiningDate',
        type: 'date',
        rules: [{ required: true, message: 'Field is required' }]
      },
      {
        label: 'Reporting Manager',
        name: 'reportingManager',
        type: 'select',
        isCombo: true,
        rules: [{ required: true, message: 'Field is required' }]
      },
      {
        label: 'Yearly Package',
        name: 'yearlyPackage',
        type: 'text',
        rules: [{ required: true, message: 'Field is required' }]
      },
      {
        label: 'Office Location',
        name: 'officeLocation',
        type: 'select',
        children: ['Nagpur', 'Noida', 'Bangloare', 'Hyderabad'].map(ele => ({ name: ele, value: ele })),
        rules: [{ required: true, message: 'Field is required' }]
      },
      {
        label: 'Job Type',
        name: 'jobType',
        type: 'select',
        children: ['Internship', 'Fresher', 'Experience'].map(ele => ({ name: ele, value: ele })),
        rules: [{ required: true, message: 'Field is required' }]
      },
      {
        label: 'Internship Stifend',
        name: 'stifend',
        type: 'text',
      },
      {
        label: 'Durations month',
        name: 'monthsDuration',
        type: 'text',
      },
      {
        label: 'First Pay',
        name: 'firstPay',
        type: 'date',
      },
      {
        label: 'Reporting Department',
        name: 'reportingDepartment',
        type: 'text',
        rules: [{ required: true, message: 'Field is required' }]
      },
      {
        label: 'Add bench policy',
        name: 'benchPolicy',
        type: 'select',
        children: [{ value: true, name: 'Yes' }, { value: false, name: 'No' }]
      },
      {
        label: 'Reply To',
        name: 'replyTo',
        type: 'select',
        isCombo: true,
        rules: [{ required: true, message: 'Field is required' }]
      },
      {
        label: 'Incentives',
        name: 'incentives',
        type: 'number',
        inputNumberProps: { addonAfter: '%' }
      },
      {
        label: 'Bench Salary',
        name: 'benchPercentages',
        type: 'number',
        inputNumberProps: { addonAfter: '%' }
      },
      {
        label: 'Client site allowance',
        name: 'clientSiteAllowance',
        type: 'checkbox',
      }
    ];
  },
  combo: [
    {
      name: 'emailTemplate',
      api: '/cms/emailTemplates',
      idKey: '_id',
      render: (e) => e.name
    },
    {
      name: 'approvalFrom',
      api: '/users/CEO/list',
      idKey: '_id',
      render: (e) => constants.GET_FULL_NAME(e)
    },
    {
      name: 'candidate',
      api: '/shortlistedCandidates',
      idKey: '_id',
      render: (e) => e.candidateName
    },
    {
      name: 'reportingManager',
      api: '/users',
      idKey: '_id',
      render: (e) => constants.GET_FULL_NAME(e)
    },
    {
      name: 'replyTo',
      api: '/users',
      idKey: '_id',
      render: (e) => constants.GET_FULL_NAME(e)
    },
  ],
  getData: () => ({}),
  actions: [
    { name: 'Add Offer Letter', actionType: 'Add' },
    { name: 'Return', actionType: 'Back' },
  ],
};
